export default "/_next/static/chunks/fonts/Domine-Regular-latin-b0be53e4c3eef2822ac28b005ba7a469.woff2";